import enums from "../enums";
import { sendSocketMessage } from "../middleware/middleware.js";

const SOCKET_PAYLOAD_PREFIX = "rmellkchZ#";

export function subscribeMatch(matchId) {
	return (dispatch) => {
		dispatch(
			sendSocketMessage({
				action: "subscribe",
				matchIds: [`${SOCKET_PAYLOAD_PREFIX}${matchId}`],
			})
		);
	};
}

export function subscribeMatches(matchIds) {
	return (dispatch) => {
		if (matchIds) {
			dispatch(
				sendSocketMessage({
					action: "subscribe",
					matchIds: matchIds.map((i) => `${SOCKET_PAYLOAD_PREFIX}${i}`),
				})
			);
		}
	};
}

export function unSubscribeMatch(matchId) {
	return (dispatch) => {
		dispatch(
			sendSocketMessage({
				action: "unsubscribe",
				matchIds: [`${SOCKET_PAYLOAD_PREFIX}:${matchId}`],
			})
		);
	};
}

export function unSubscribeMatches(matchIds) {
	return (dispatch) => {
		if (matchIds) {
			dispatch(
				sendSocketMessage({
					action: "unsubscribe",
					matchIds: matchIds.map((i) => `${SOCKET_PAYLOAD_PREFIX}${i}`),
				})
			);
		}
	};
}

export function subscribeMatchList(matchIdList) {
	return (dispatch) => {
		dispatch(
			sendSocketMessage({
				action: "subscribe",
				matchIds: matchIdList.map((m) => `${SOCKET_PAYLOAD_PREFIX}${m}`),
			})
		);
	};
}

export function unSubscribeMatchList(matchIdList) {
	return (dispatch) => {
		dispatch(
			sendSocketMessage({
				action: "unsubscribe",
				matchIds: matchIdList.map((m) => `${SOCKET_PAYLOAD_PREFIX}${m}`),
			})
		);
	};
}

export function openNotification(tenant, username, time) {
	return (dispatch) => {
		dispatch(
			sendSocketMessage({
				action: "notificationseen",
				notification: { tenant, username: `${username}#${time}` },
			})
		);
	};
}

export function clearSessionError(matchIdList) {
	return (dispatch) => {
		dispatch({
			type: enums.SESSION_RESET,
		});
	};
}
